import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, input } from '@angular/core';
import { EmptyStateComponent } from '../empty-state/empty-state.component';

@Component({
  selector: 'fdr-past-performance-ui-table-state',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [EmptyStateComponent],
  templateUrl: './table-state.component.html',
  styleUrls: ['./table-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableStateComponent {
  isLoading = input.required<boolean>();
  hasData = input.required<boolean>();
  totalItems = input.required<number>();
  emptyTitle = input<string>('PD.LABELS.NO_DATA_DISPATCH_AVAILABLE');
  emptySubtitle = input<string | null>('PD.LABELS.SELECTED_FILTERS');
  emptyIcon = input<string | null>('search_off');
}
